import type { ScheduledPostDto } from "@nlc/shared-types";

import { fromDate, toCalendarDate, toTime } from "@internationalized/date";
import { Delta } from "quill";

import type { DesignFile } from "./design-step/types";
import type { PostType } from "./post-type-step/postTypes";
import type { ScheduleDraft } from "./scheduleDraft";

import { POST_TYPES } from "./post-type-step/postTypes";

export function postTypeOf(post: ScheduledPostDto): PostType | undefined {
  return POST_TYPES.find(
    (postType) =>
      postType.platform === post.page?.platform &&
      postType.format === post.format,
  );
}

export function designFilesOf(post: ScheduledPostDto): DesignFile[] {
  return post.designs.flatMap((design) =>
    design.url
      ? [
          {
            createdAt: post.createdAt,
            extension: design.name.split(".").pop() ?? "",
            id: design.id,
            isDirectory: false,
            name: design.name,
            size: 0,
            type: "file",
            url: design.url,
          },
        ]
      : [],
  );
}

export function scheduleDraftOf(
  post: ScheduledPostDto,
  timeZone: string,
): ScheduleDraft {
  const scheduledAt = fromDate(new Date(post.scheduledAt), timeZone);

  return {
    caption: new Delta().insert(post.caption ?? ""),
    date: toCalendarDate(scheduledAt),
    goLive: "later",
    name: post.name,
    time: toTime(scheduledAt),
  };
}
